import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch } from "../../lib/api";

const addStableIds = (items = [], prefix) => items.map((item) => ({ ...item, item_id: item.item_id || `${prefix}_${crypto.randomUUID()}` }));

const normalizeSettings = (data) => ({
  ...data,
  policies: data.policies || [],
  hero_slides: data.hero_slides || [],
  who_we_help: addStableIds(data.who_we_help, "audience"),
  contacts: addStableIds(data.contacts, "contact"),
  client_logos: addStableIds(data.client_logos, "client"),
  testimonials: addStableIds(data.testimonials, "testimonial"),
  accreditations: addStableIds(data.accreditations, "accreditation"),
});

export const useAdminSettings = () => {
  const queryClient = useQueryClient();
  const [form, setForm] = useState(null);
  const { data } = useQuery({ queryKey: ["admin-settings"], queryFn: () => apiFetch("/admin/settings"), select: normalizeSettings });
  useEffect(() => { if (data) setForm(data); }, [data, setForm]);
  const save = useMutation({
    mutationFn: () => apiFetch("/admin/settings", { method: "PUT", body: JSON.stringify(form) }),
    onSuccess: (saved) => { setForm(saved); queryClient.invalidateQueries({ queryKey: ["public-content"] }); toast.success("Site settings updated"); },
    onError: (error) => toast.error(error.message),
  });
  const updateCollectionItem = (collection, index, field, value) => setForm((current) => ({ ...current, [collection]: current[collection].map((item, itemIndex) => itemIndex === index ? { ...item, [field]: value } : item) }));
  return { form, save, setForm, updateCollectionItem };
};